import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { closeStationery } from "./closeStationery";

export const saveStationery = async (actives: stdObject, params: stdObject) => {
  const {
    t,
    customUpdate,
    docValues,
    closeMsg,
    setMsg3,
    setModalData3,
    setDocValues,
    setStationeryModal,
    setMsg,
    documentAction,
    openWindow,
    logoutAction,
  } = params;
  let staMsg =
    docValues.data.NOMDOC.trim() === ""
      ? "enterAName"
      : docValues.data.ANCDOC < 100
        ? "incorrectPageWidth"
        : docValues.data.ALTDOC < 100
          ? "incorrectPageHeight"
          : false;
  if (staMsg) {
    setMsg3("custom3");
    setModalData3({
      code: "warning",
      title: t(`p.${staMsg}`),
    });
  } else {
    setMsg3("loading");
    const payloadSaveStationery = {
      data: docValues.data,
      parts: docValues.parts.filter((e: stdObject) => actives[e.NUMPAR]),
    };
    console.log("payloadSaveStationery", payloadSaveStationery);
    const responseSaveStationery: stdObject = await sendData({
      endPoint: "saveStationery",
      payload: payloadSaveStationery,
      logoutAction,
    });
    console.log(
      "responseSaveStationery",
      responseSaveStationery,
      Object.keys(responseSaveStationery)
        .map((e) => responseSaveStationery[e])
        .join(""),
    );
    if (responseSaveStationery.success && responseSaveStationery.status) {
      customUpdate.current = {
        stationeryInfo: docValues.index,
        info: responseSaveStationery.info[0],
      };
      closeMsg(3);
      closeStationery(true, {
        docValues,
        setDocValues,
        setStationeryModal,
        setMsg,
        documentAction,
        openWindow,
        closeMsg,
      });
    } else {
      setMsg3("error");
    }
    return;
  }
};
